import CreditBalanceDetailPanel from "./creditBalanceDetailPanel.container";

export default CreditBalanceDetailPanel;
